var _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMicrophone2 = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/microphone-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/microphone-2_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microphone-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 16.25C9.38 16.25 7.25 14.12 7.25 11.5V6C7.25 3.38 9.38 1.25 12 1.25C14.62 1.25 16.75 3.38 16.75 6V11.5C16.75 14.12 14.62 16.25 12 16.25ZM12 2.75C10.21 2.75 8.75 4.21 8.75 6V11.5C8.75 13.29 10.21 14.75 12 14.75C13.79 14.75 15.25 13.29 15.25 11.5V6C15.25 4.21 13.79 2.75 12 2.75Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0001 19.7504C7.3701 19.7504 3.6001 15.9804 3.6001 11.3504V9.65039C3.6001 9.24039 3.9401 8.90039 4.3501 8.90039C4.7601 8.90039 5.1001 9.24039 5.1001 9.65039V11.3504C5.1001 15.1504 8.2001 18.2504 12.0001 18.2504C15.8001 18.2504 18.9001 15.1504 18.9001 11.3504V9.65039C18.9001 9.24039 19.2401 8.90039 19.6501 8.90039C20.0601 8.90039 20.4001 9.24039 20.4001 9.65039V11.3504C20.4001 15.9804 16.6301 19.7504 12.0001 19.7504Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3901 7.18031C13.3101 7.18031 13.2201 7.17031 13.1301 7.14031C12.4001 6.87031 11.6001 6.87031 10.8701 7.14031C10.4801 7.28031 10.0501 7.08031 9.91012 6.69031C9.77012 6.30031 9.97012 5.87031 10.3601 5.73031C11.4201 5.35031 12.5901 5.35031 13.6501 5.73031C14.0401 5.87031 14.2401 6.30031 14.1001 6.69031C13.9801 6.99031 13.6901 7.18031 13.3901 7.18031Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.8001 9.30031C12.7301 9.30031 12.6701 9.29031 12.6001 9.27031C12.2001 9.16031 11.7901 9.16031 11.3901 9.27031C10.9901 9.38031 10.5801 9.14031 10.4701 8.74031C10.3601 8.35031 10.6001 7.94031 11.0001 7.83031C11.6501 7.65031 12.3501 7.65031 13.0001 7.83031C13.4001 7.94031 13.6401 8.35031 13.5301 8.75031C13.4401 9.08031 13.1301 9.30031 12.8001 9.30031Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12 22.75C11.59 22.75 11.25 22.41 11.25 22V19C11.25 18.59 11.59 18.25 12 18.25C12.41 18.25 12.75 18.59 12.75 19V22C12.75 22.41 12.41 22.75 12 22.75Z",
    fill: "#757575"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMicrophone2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/microphone-2.0078e30d.svg";
export { ForwardRef as ReactComponent };